import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";

export function VoucherForm() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="name"
          label={translate("voucher_batch_admin.fields.name")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="type"
          label={translate("voucher_batch_admin.fields.type")}
          options={[
            { value: "cinema", label: translate("voucher_batch_admin.options.cinema") },
          ]}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.DatePicker
          name="valid_until"
          label={translate("voucher_batch_admin.fields.valid_until")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="vouchers"
          label={translate("voucher_batch_admin.fields.vouchers")}
          instructions={translate("voucher_batch_admin.instructions.vouchers")}
          multiline
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="active"
          label={translate("voucher_batch_admin.fields.active")}
          defaultChecked={true}
          required
        />
      </Grid>
    </Grid>
  )
}
